import { FunctionComponent } from 'react';

import Alert from '@Components/Alert';
import commonConstants from '@Constants/common.constants';

import ModalAlertProps from './ModalAlert.types';

const ModalAlert: FunctionComponent<ModalAlertProps> = (
  props: ModalAlertProps
): JSX.Element => {
  const { alertState, ...resProps } = props;

  /** Reset Alert */
  const resetAlert = () => {
    if (alertState?.resetAlert) {
      alertState.resetAlert({
        ...alertState,
        openAlert: false,
      });
    }
  };

  return (
    <Alert
      open={alertState?.openAlert}
      text={alertState?.message}
      severity={alertState?.severity}
      onClose={resetAlert}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'top',
      }}
      sx={{
        position: 'absolute',
        width: 'calc(100% - 4.8rem)',
        left: '2.4rem',
        top: '1.6rem',
      }}
      closeBtnProps={{
        onClick: resetAlert,
        className: 'modalAlertCloseBtn',
      }}
      autoHideDuration={commonConstants.ALERT_HIDING_TIME}
      alertProps={{
        sx: {
          '&.MuiAlert-filledError': {
            minWidth: '100%',
            backgroundColor: ({ colors }) => colors.modalError,

            '& .MuiTypography-root, & .MuiIconButton-root.modalAlertCloseBtn': {
              color: 'text.primary',
            },
          },
        },
      }}
      {...resProps}
    />
  );
};

export default ModalAlert;
